export const getVATStatus = () => {
    const cookies = document.cookie.split(';');
    const vatCookie = cookies.find(c => c.trim().startsWith('IncludeVat='));
    if (vatCookie) {
        const cookieValue = vatCookie.split('=')[1];
        return cookieValue === 'true';
    }
    return true;
};